import getCountryDomesticMessagePrices from "../api/getCountryDomesticMessagePrices";

export const EMPTY_MESSAGE_PRICING = { marketing: undefined, utility: undefined, conversation: undefined };

export const getMessagePricing = async ({ iso, selectedDomain, onError }: { iso?: string, selectedDomain?: string, onError?: (message: string) => void }) => {
    if(iso && selectedDomain) {
        const response = await getCountryDomesticMessagePrices(iso, selectedDomain);
        if(response.data?.state === 'success') {
            return response.data.data;
        } else {
            onError && onError(`Message Pricing for ${iso} could not be found`);
            return EMPTY_MESSAGE_PRICING;
        }
    } else {
        return EMPTY_MESSAGE_PRICING;
    }
}